// src/lib/posthogService.ts
import { withPostHog } from './posthog';
import type { UserProfile } from '../types/api';

interface TrackProperties {
  [key: string]: string | number | boolean | null | undefined;
}

class PostHogService {
  identify(user: UserProfile): void {
    const userId = String(user.id);
    const name = user.username || `${user.first_name || ''} ${user.last_name || ''}`.trim();

    withPostHog((posthog) => {
      posthog.identify(userId, {
        email: user.email,
        name: name || undefined,
        first_name: user.first_name,
        last_name: user.last_name,
        username: user.username,
        subscription_tier: user.subscription?.tier || 'free',
        is_staff: user.is_staff || false,
      });

      posthog.register({
        subscription_tier: user.subscription?.tier || 'free',
        user_id: userId,
      });
    });
  }

  reset(): void {
    withPostHog((posthog) => posthog.reset());
  }

  track(eventName: string, properties?: TrackProperties): void {
    // Build properties now: the call may be queued until the SDK has loaded.
    const eventProperties = {
      ...properties,
      timestamp: new Date().toISOString(),
    };

    withPostHog((posthog) => posthog.capture(eventName, eventProperties));
  }

  trackPageView(pageName: string, additionalProps?: TrackProperties): void {
    const pageProperties = {
      page_name: pageName,
      page_path: window.location.pathname,
      $current_url: window.location.href,
      referrer: document.referrer || undefined,
      ...additionalProps,
    };

    withPostHog((posthog) => posthog.capture('$pageview', pageProperties));
  }
}

export const posthogService = new PostHogService();
